import { FieldsEntityInstanceResponse } from '@models/api';
import { FormFieldModel } from '@models/module/fields/main';
import { FormItem } from '@shared/components/fields/common';

export type DmFormField = FormItem & Pick<FormFieldModel, 'triggeredFields'>;

export type DmGridFields = Pick<
  FieldsEntityInstanceResponse,
  | 'autosaveEnabled'
  | 'canChangeAssignment'
  | 'emails'
  | 'emailsDataSource'
  | 'hideRolesNotify'
  | 'manualAssignUsers'
  | 'roleToExcludeIds'
  | 'requiresNonBindingSignature'
  | 'workflowGroups'
  | 'screenLabel'
> & {
  fields: DmFormField[];
};
